import { SignalWatcher, WithDisposable } from '@blocksuite/global/lit';
import { ShadowlessElement } from '@blocksuite/std';
import { html, type TemplateResult } from 'lit';
import { property } from 'lit/decorators.js';

import {
  swimlaneCountStyle,
  swimlaneHeaderCollapsedStyle,
  swimlaneHeaderStyle,
} from './swimlanes-css.js';

export class GanttSwimlaneHeader extends SignalWatcher(
  WithDisposable(ShadowlessElement)
) {
  @property({ attribute: false })
  accessor label = '';

  @property({ attribute: false })
  accessor rowCount = 0;

  @property({ type: Boolean })
  accessor collapsed = false;

  @property({ attribute: false })
  accessor onToggle: (() => void) | undefined;

  override connectedCallback(): void {
    super.connectedCallback();
    this.classList.add(swimlaneHeaderStyle);
  }

  override updated(): void {
    this.classList.toggle(swimlaneHeaderCollapsedStyle, this.collapsed);
  }

  override render(): TemplateResult {
    return html`
      <span>${this.collapsed ? '▸' : '▾'}</span>
      <span>${this.label}</span>
      <span class=${swimlaneCountStyle}>(${this.rowCount})</span>
      <span style="flex: 1"></span>
    `;
  }

  override firstUpdated(): void {
    this.addEventListener('click', () => this.onToggle?.());
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'dv-gantt-swimlane-header': GanttSwimlaneHeader;
  }
}
